var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"title"},[_vm._v("album page.")]),_c('album-detail-partial',{attrs:{"editMode":_vm.editMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }